var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('div',{staticClass:"section content is-size-7"},[_c('p',[_vm._v("\n      E-Mail: "),_c('a',{attrs:{"href":"mailto:ie.mg.cuca@778mobile.com"}},[_vm._v("ie.mg.cuca@778mobile.com")]),_vm._v(" "),_c('br'),_vm._v("\n      Helpline: "),_c('a',{attrs:{"href":"tel:+35315566568"}},[_vm._v("15566568")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bcc3386","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LangKyf/IE/Help.vue
// module id = null
// module chunks = 